const RUNS = [
  { id: 'WEST', label: 'AAA', areas: ['AAA'], bays: 9, levelCounts: [3, 3, 3, 3, 3, 3, 3, 2, 2], heightFt: 18 },
  { id: 'R1', label: 'AA / A', areas: ['AA', 'A'], bays: 10, levels: 5, sides: { AA: 'left', A: 'right' }, heightFt: 30, numberedFromReceiving: ['left', 'right'] },
  {
    id: 'R2', label: 'B / SM', areas: ['B', 'SM'], bays: 8, levels: 5, sides: { B: 'left', SM: 'right' }, heightFt: 30, numberedFromReceiving: ['left', 'right'],
    // Ground opening of each bay holds one 8 ft mobile shelving section (5 shelves A-E, 8 bins across).
    // Sections 01-08 fill the B face from Receiving; the run wraps at the far wall, so 09-13 come back toward Receiving on the SM face, then SM-01..03 with SM-03 at the dock doors.
    // F/G/H are the three pallet levels (two positions per bay) above the shelving.
    shelving: {
      B: {
        binsAcross: 8,
        shelfLevels: 5,
        faces: [
          { side: 'left', sections: [1, 8], startBay: 1 },
          { side: 'right', sections: [9, 13], startBay: 8, bayOrder: 'descending' },
        ],
        upperLevels: { F: 2, G: 3, H: 4, I: 5 },
        palletRun: {
          section: 1,
          perBay: 2,
          faces: [
            { side: 'left', positions: [1, 16], bayOrder: 'ascending' },
            // Both sides number from Receiving; the pallet run wraps at the far wall, so F-17 sits over B-09 (bay 8, far end) and F-32 over SM-03 (bay 1, dock doors).
            { side: 'right', positions: [17, 32], bayOrder: 'descending' },
          ],
          verified: true,
          source: 'walkthrough 2026-09-29: run wraps at the far wall; SM aisle SM-03→SM-01→B-13→B-09 from Receiving; anchors F-01/B-01-E-01 (Receiving), F-16/B-08-E-08, F-17/B-09-E-01 (far wall), F-26/B-13-E-08, F-27/SM-01-E-01, F-32/SM-03-E-09 (Receiving); H-01..32 sit directly above G-01..32 (Joshua 09/29); I-01..32 sit directly above H-01..32 at level 5 (Bryan/Joshua 10/07)',
        },
      },
      SM: {
        binsAcross: 14,
        shelfLevels: 5,
        faces: [{ side: 'right', sections: [1, 3], startBay: 3, bayOrder: 'descending' }],
      },
    },
  },
  {
    id: 'R3', label: 'C / D', areas: ['C', 'D'], bays: 8, levels: 5, sides: { C: 'left', D: 'right' }, heightFt: 30,
  },
  { id: 'EAST', label: 'E', areas: ['E'], bays: 8, levels: 2, groundLevelFt: 10, heightFt: 16 },
  { id: 'NORTH', label: 'BB', areas: ['BB'], bays: 6, levels: 3, heightFt: 18 },
];

// Section to bay crosswalk. Crosswalk rows win over face arithmetic in placeLocation.
const R2_WALKTHROUGH_SOURCE = 'walkthrough 2026-09-29: run wraps at the far wall; SM aisle SM-03→SM-01→B-13→B-09 from Receiving; anchors F-01/B-01-E-01 (Receiving), F-16/B-08-E-08, F-17/B-09-E-01 (far wall), F-26/B-13-E-08, F-27/SM-01-E-01, F-32/SM-03-E-09 (Receiving); H-01..32 sit directly above G-01..32 (Joshua 09/29)';
const SHELVING_SECTION_CROSSWALK = [
  ...Array.from({ length: 13 }, (_, index) => {
    const section = index + 1;
    return {
      area: 'B',
      section,
      runId: 'R2',
      side: section <= 8 ? 'left' : 'right',
      bay: section <= 8 ? section : 17 - section,
      verified: true,
      source: R2_WALKTHROUGH_SOURCE,
    };
  }),
  ...[[3, 1], [2, 2], [1, 3]].map(([section, bay]) => ({
    area: 'SM',
    section,
    runId: 'R2',
    side: 'right',
    bay,
    verified: true,
    source: R2_WALKTHROUGH_SOURCE,
  })),
];
const END_CAP_CROSSWALK = [
  {
    code: 'EC-01-A-01',
    runId: 'R3',
    bay: 1,
    level: 1,
    verified: true,
    source: 'Bryan 10/07/2026: far end of the C/D run, opposite Receiving',
  },
  {
    code: 'EC-01-A-02',
    runId: 'R2',
    bay: 8,
    level: 1,
    verified: true,
    source: 'Bryan 10/07/2026: far end of the B/SM run, opposite Receiving',
  },
];
const crosswalkFor = (area, section) => SHELVING_SECTION_CROSSWALK.find(
  (row) => row.area === area && row.section === section,
) || null;

const LEVEL_FIRST_AREAS = new Set(['AA', 'AAA', 'BB', 'C', 'D', 'E']);
const RUN_BY_AREA = new Map(RUNS.flatMap((run) => run.areas.map((area) => [area, run])));

const toNumber = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : null;
};

const partsFor = (row) => {
  if (Array.isArray(row.code_parts) && row.code_parts.length === 4) return row.code_parts;
  if (typeof row.location_code !== 'string') return null;
  const parts = row.location_code.split('-');
  return parts.length === 4 ? parts : null;
};

const isLevelFirst = (row) => {
  const parts = partsFor(row);
  const area = row.area || parts?.[0];
  return LEVEL_FIRST_AREAS.has(area)
    || (area === 'A' && String(parts?.[2] || '').toUpperCase() === 'A' && row.storage_form === 'Pallet');
};

// Physical slot along the run (0 = far end, run.bays - 1 = Receiving end) of a logical bay number.
const baySlot = (run, side, bay) => (run.numberedFromReceiving?.includes(side) ? run.bays - bay : bay - 1);
const bayAtSlot = (run, side, slot) => (run.numberedFromReceiving?.includes(side) ? run.bays - slot : slot + 1);
const endCapEnd = (run, bay) => (baySlot(run, 'left', bay) === 0 ? 'far' : 'receiving');
// Pallet positions per bay for level-first areas (2 on AA's 10-bay, 20-position run).
const positionsPerBay = (run, maxPosition) => Math.max(1, Math.ceil((maxPosition || 1) / run.bays));

const levelsFor = (run, bay) => run.levelCounts?.[bay - 1] || run.levels;
const shelvingFace = (cfg, section) => cfg?.faces?.find((face) => section >= face.sections[0] && section <= face.sections[1]) || null;
const isOverflow = (run, area, bay, level) => !run || bay > run.bays || level > levelsFor(run, bay) || (area === 'SM' && bay > 3);

// Review flags applied to every code-inferred placement.
// Precedence: unplaced > overflow > ambiguous > crosswalk.
const reviewFor = (placement) => {
  if (!placement.placed) {
    return { review: 'unplaced', reviewNote: 'No placement could be inferred from the location code' };
  }
  if (placement.overflow) {
    return { review: 'overflow', reviewNote: 'Placement falls outside the approved rack structure' };
  }
  const upperPalletLevel = placement.schema === 'shelving-upper'
    || (placement.schema === 'bay-first' && placement.level > 1);
  if (placement.schema === 'shelving-upper' && placement.source !== 'pallet-run') {
    return {
      review: 'ambiguous',
      reviewNote: 'Upper-level code in a shelving section outside the B-01 pallet run; physical position unconfirmed',
    };
  }
  if (upperPalletLevel && placement.slot > 4) {
    return { review: 'ambiguous', reviewNote: 'N positions on one level cannot fit a single bay; likely numbered along the run' };
  }
  if (
    (placement.schema === 'shelving-section' && placement.crosswalkVerified === false)
    || (placement.source === 'pallet-run' && placement.crosswalkVerified === false)
  ) {
    return { review: 'crosswalk', reviewNote: 'Section-to-bay mapping is an unverified guess pending Bryan validation' };
  }
  return { review: null, reviewNote: null };
};

const finish = (placement) => ({ ...placement, ...reviewFor(placement) });

// Code inference only; ignores persisted geometry columns. The server uses this
// to backfill and to diff against validated placements.
const inferPlacement = (row, context = {}) => {
  const endCap = END_CAP_CROSSWALK.find((placement) => placement.code === row.location_code);
  if (endCap) {
    const run = RUNS.find((item) => item.id === endCap.runId);
    return finish({
      placed: true,
      runId: endCap.runId,
      side: 'end',
      bay: endCap.bay,
      endCapEnd: endCapEnd(run, endCap.bay),
      level: 1,
      slot: 1,
      structure: 'end-cap',
      schema: 'end-cap',
      source: 'crosswalk',
      provisional: true,
      overflow: false,
    });
  }
  const parts = partsFor(row);
  const area = row.area || parts?.[0];
  const run = RUN_BY_AREA.get(area);
  if (!run || !parts) return finish({ placed: false, provisional: true, overflow: false });

  const s2 = toNumber(parts[1]);
  const s3 = parts[2];
  const s4 = toNumber(parts[3]);
  if (!s2 || !s4) return finish({ placed: false, provisional: true, overflow: false });

  if (run.shelving?.[area]) {
    const cfg = run.shelving[area];
    const section = s2;
    const letter = String(s3).toUpperCase();
    const face = shelvingFace(cfg, section);
    const crosswalk = crosswalkFor(area, section);
    const bay = crosswalk
      ? crosswalk.bay
      : (face
        ? face.bayOrder === 'descending'
          ? face.startBay - (section - face.sections[0])
          : face.startBay + (section - face.sections[0])
        : run.bays + section);
    const side = crosswalk ? crosswalk.side : (face?.side || run.sides?.[area] || 'center');
    const source = crosswalk ? 'crosswalk' : 'code';
    const upperLevel = cfg.upperLevels?.[letter];
    const palletRun = cfg.palletRun;
    if (palletRun && section === palletRun.section && upperLevel) {
      const palletFace = palletRun.faces.find(
        (candidate) => s4 >= candidate.positions[0] && s4 <= candidate.positions[1],
      );
      if (!palletFace) {
        return finish({
          placed: true,
          runId: run.id,
          side: 'center',
          bay: run.bays + 1,
          level: upperLevel,
          slot: s4,
          schema: 'shelving-upper',
          section,
          source: 'pallet-run',
          crosswalkVerified: palletRun.verified,
          provisional: true,
          overflow: true,
        });
      }
      const k = s4 - palletFace.positions[0];
      const bayIndex = Math.floor(k / palletRun.perBay);
      const palletBay = palletFace.bayOrder === 'ascending'
        ? bayIndex + 1
        : run.bays - bayIndex;
      return finish({
        placed: true,
        runId: run.id,
        side: palletFace.side,
        bay: palletBay,
        level: upperLevel,
        slot: (k % palletRun.perBay) + 1,
        schema: 'shelving-upper',
        section,
        source: 'pallet-run',
        crosswalkVerified: palletRun.verified,
        provisional: true,
        overflow: upperLevel > levelsFor(run, palletBay),
      });
    }
    if (upperLevel) {
      return finish({
        placed: true,
        runId: run.id,
        side,
        bay,
        level: upperLevel,
        slot: s4,
        schema: 'shelving-upper',
        section,
        source,
        crosswalkVerified: crosswalk ? crosswalk.verified : undefined,
        provisional: true,
        overflow: !face || upperLevel > levelsFor(run, bay),
      });
    }
    const shelf = 'ABCDEFG'.indexOf(letter) + 1;
    const bin = s4;
    return finish({
      placed: true,
      runId: run.id,
      side,
      bay,
      level: 1,
      shelf,
      slot: bin,
      schema: 'shelving-section',
      structure: 'shelving',
      section,
      bin,
      binsPerBay: cfg.binsAcross,
      shelfLevels: cfg.shelfLevels,
      source,
      crosswalkVerified: crosswalk ? crosswalk.verified : undefined,
      provisional: true,
      overflow: !face || shelf < 1 || shelf > cfg.shelfLevels || bin > cfg.binsAcross,
    });
  }

  let bay;
  let level;
  let slot;
  let schema;
  if (isLevelFirst(row)) {
    schema = 'level-first';
    level = s2;
    const maxPosition = context.maxPositionsByArea?.[area] || s4;
    const perBay = positionsPerBay(run, maxPosition);
    bay = Math.ceil(s4 / perBay);
    slot = ((s4 - 1) % perBay) + 1;
  } else {
    schema = 'bay-first';
    bay = s2;
    level = 'ABCDEFG'.indexOf(String(s3).toUpperCase()) + 1;
    slot = s4;
  }

  if (!bay || !level || level < 1) return finish({ placed: false, provisional: true, overflow: false });
  const overflow = isOverflow(run, area, bay, level);
  return finish({
    placed: true,
    runId: run.id,
    side: run.sides?.[area] || 'center',
    bay,
    level,
    slot,
    schema,
    source: 'code',
    provisional: true,
    overflow,
  });
};

const placeLocation = (row, context = {}) => {
  const persisted = row.geometry_status === 'validated' || row.geometry_status === 'inferred';
  if (persisted && row.geometry_run && row.geometry_bay && row.geometry_level) {
    const run = RUNS.find((item) => item.id === row.geometry_run);
    const bay = Number(row.geometry_bay);
    const level = Number(row.geometry_level);
    const schema = row.geometry_schema || 'validated';
    const cfg = run?.shelving?.[row.area];
    const endCap = schema === 'end-cap';
    return {
      placed: true,
      runId: row.geometry_run,
      side: endCap ? 'end' : row.geometry_side || (row.area === 'AAA' ? 'center' : run?.sides?.[row.area] || 'center'),
      bay,
      level,
      slot: Number(row.geometry_slot ?? row.geometry_x) || 1,
      ...(row.geometry_shelf ? { shelf: Number(row.geometry_shelf) } : {}),
      ...(row.geometry_section ? { section: Number(row.geometry_section) } : {}),
      ...(schema === 'shelving-section' && cfg ? {
        structure: 'shelving',
        ...(row.geometry_slot ? { bin: Number(row.geometry_slot) } : {}),
        binsPerBay: cfg.binsAcross,
        shelfLevels: cfg.shelfLevels,
      } : {}),
      ...(endCap ? { structure: 'end-cap', endCapEnd: endCapEnd(run, bay) } : {}),
      schema,
      provisional: row.geometry_status !== 'validated',
      source: row.geometry_source || 'persisted',
      overflow: endCap ? false : row.geometry_overflow ?? isOverflow(run, row.area, bay, level),
      review: row.geometry_review || null,
      reviewNote: row.geometry_review_note || null,
    };
  }
  const inferred = inferPlacement(row, context);
  return {
    ...inferred,
    source: inferred.source === 'pallet-run' ? 'pallet-run' : 'code',
  };
};

// Shape emitted to KIP warehouse tools; sides is the array of areas per face.
const structureRuns = () => RUNS.map((run) => ({
  id: run.id,
  label: run.label,
  areas: run.areas.slice(),
  bays: run.bays,
  levels: run.levels || Math.max(...run.levelCounts),
  heightFt: run.heightFt,
  groundLevelFt: run.groundLevelFt ?? 6,
  sides: run.sides ? run.areas.slice() : [],
}));

const cellKey = (runId, side, bay, level) => `${runId}|${side}|${bay}|${level}`;

const sectionsThatFit = (run, area) => {
  const cfg = run?.shelving?.[area];
  return cfg ? cfg.faces.reduce((sum, face) => sum + (face.sections[1] - face.sections[0] + 1), 0) : 0;
};

const buildModel = (scenePayload) => {
  const locations = scenePayload?.locations || [];
  const inventory = scenePayload?.inventory || [];
  const profiles = new Map((scenePayload?.capacityProfiles || []).map((profile) => [profile.profile_id, profile]));
  const inventoryByCode = new Map();
  const bySku = new Map();
  const byProductTerm = new Map();
  const productTerms = ['name', 'category', 'subcategory', 'demandTier', 'family'];
  inventory.forEach((row) => {
    const rows = inventoryByCode.get(row.location_code) || [];
    rows.push(row);
    inventoryByCode.set(row.location_code, rows);
    if (row.sku) {
      const matches = bySku.get(row.sku) || [];
      matches.push(row);
      bySku.set(row.sku, matches);
    }
    productTerms.forEach((field) => {
      const term = row.product?.[field];
      if (typeof term !== 'string' || !term.trim()) return;
      const key = term.trim().toLowerCase();
      const codes = byProductTerm.get(key) || new Set();
      codes.add(row.location_code);
      byProductTerm.set(key, codes);
    });
  });
  const maxPositionsByArea = {};
  locations.forEach((row) => {
    if (row.geometry_status === 'no_fixed_spot' || !isLevelFirst(row)) return;
    const parts = partsFor(row);
    const position = toNumber(parts?.[3]);
    const area = row.area || parts?.[0];
    if (position && area) maxPositionsByArea[area] = Math.max(maxPositionsByArea[area] || 0, position);
  });

  const positionsPerBayByArea = {};
  Object.keys(maxPositionsByArea).forEach((area) => {
    const run = RUN_BY_AREA.get(area);
    if (run && maxPositionsByArea[area]) positionsPerBayByArea[area] = positionsPerBay(run, maxPositionsByArea[area]);
  });

  const cells = new Map();
  const unplaced = [];
  const noFixedSpot = [];
  const outsideStructure = new Map();
  const shelvingSections = new Map();
  const byCode = new Map();
  const runExtensions = RUNS.map((run) => ({ ...run, levelCounts: run.levelCounts?.slice() }));

  locations.forEach((row) => {
    const placement = placeLocation(row, { maxPositionsByArea });
    const profile = profiles.get(row.capacity_profile_id);
    const used = (inventoryByCode.get(row.location_code) || []).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    const capacityKnown = !row.manual_capacity && profile && typeof profile.max_units === 'number';
    const modelLocation = {
      ...row,
      inventory: inventoryByCode.get(row.location_code) || [],
      placement,
      used,
      capacity: capacityKnown ? profile.max_units : 0,
      capacityKnown,
    };
    byCode.set(row.location_code, modelLocation);
    if (row.geometry_status === 'no_fixed_spot') {
      noFixedSpot.push(modelLocation);
      return;
    }
    if (!placement.placed) {
      unplaced.push(modelLocation);
      return;
    }
    if (placement.structure === 'shelving') {
      const key = `${placement.runId}|${placement.side}|${placement.section}`;
      const run = RUNS.find((item) => item.id === placement.runId);
      const cfg = run?.shelving?.[row.area];
      const section = shelvingSections.get(key) || {
        runId: placement.runId,
        side: placement.side,
        area: row.area,
        section: placement.section,
        startBay: placement.bay,
        endBay: placement.bay,
        fits: Boolean(shelvingFace(cfg, placement.section)),
        locations: [],
      };
      section.locations.push(modelLocation);
      shelvingSections.set(key, section);
    }
    if (placement.overflow) {
      const rows = outsideStructure.get(placement.runId) || [];
      rows.push(modelLocation);
      outsideStructure.set(placement.runId, rows);
      return;
    }
    const key = cellKey(placement.runId, placement.side, placement.bay, placement.level);
    const cell = cells.get(key) || {
      key,
      runId: placement.runId,
      side: placement.side,
      bay: placement.bay,
      level: placement.level,
      locations: [],
      used: 0,
      capacity: 0,
      capacityKnown: true,
      overflow: false,
    };
    if (placement.structure === 'shelving') {
      cell.structure = 'shelving';
      cell.binsPerBay = placement.binsPerBay;
      cell.shelfLevels = placement.shelfLevels;
    }
    if (placement.structure === 'end-cap') {
      cell.structure = 'end-cap';
      cell.endCapEnd = placement.endCapEnd;
    }
    cell.locations.push(modelLocation);
    cell.used += modelLocation.inventory.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    if (row.manual_capacity || !profile || typeof profile.max_units !== 'number') {
      cell.capacityKnown = false;
    } else {
      cell.capacity += profile.max_units;
    }
    cells.set(key, cell);
  });

  return { runs: runExtensions, cells, outsideStructure, shelvingSections, unplaced, noFixedSpot, byCode, bySku, byProductTerm, positionsPerBay: positionsPerBayByArea };
};

const cellKeyForPlacement = cellKey;

module.exports = {
  RUNS,
  SHELVING_SECTION_CROSSWALK,
  END_CAP_CROSSWALK,
  baySlot,
  bayAtSlot,
  endCapEnd,
  placeLocation,
  isLevelFirst,
  inferPlacement,
  sectionsThatFit,
  structureRuns,
  buildModel,
  cellKeyForPlacement,
};
